import * as actions from "./actions";

export const onSelectedCostToTradeLotSizesChange = (payload) => ({
  type: actions.ON_SELECTED_COST_TO_TRADE_LOT_SIZES_CHANGE,
  payload: { ...payload }
});



// WEBPACK FOOTER //
// ./src/store/analytics/chart-cost-to-trade-lot-sizes/action-creators.js